import React, {Component} from "react";
import {connect} from "react-redux";
import {Button, message, Popconfirm} from "antd";
import {Route, Switch} from "react-router-dom";
import axios from "util/Api";

import List from "../../components/List";
import Create from "./create";
import StepCreate from './step-create'
import {
  createNewSpare,
  createResource,
  deleteResource,
  fetchResource,
  generateSparePartName,
  getResource,
  getResourceForDownload,
  saveResourceQuery,
  sparePartNameGenerationClear,
  updateResource
} from "../../appRedux/actions/SparePart";
import {fetchResource as fetchSparePartType} from "../../appRedux/actions/SparePartType";
import {fetchFilter, fetchRelationshipSearchData} from "../../appRedux/actions";
import {
  faviconDynamicFunction,
  getColumnSearchProps,
  getRenderForFieldByType,
  sanitizeFieldName
} from "../../util/methods";
import AccessControl from "../../components/AccessControl";
import * as _ from "lodash";
import PurchaseHistory from "./purchase-history";

export class SparePart extends Component {
  initialQueryState = {
    sort: {
      field: "",
      order: ""
    },
    pagination: {
      pageSize: 10,
      current: 1
    },
    filters: {}
  };

  state = {
    fields: {
      name: {
        value: ""
      },
      description: {
        value: ""
      }
    },
    query: this.initialQueryState,
    columns: [],
    visibleColumns: [],
    togglingActiveId: null
  };

  constructor(props) {
    super(props);
    props.saveResourceQuery(this.initialQueryState);
  }

  componentDidMount() {
    this.fetchList();
    this.props.fetchFilter(this.props.resourceName);
  }

  componentWillReceiveProps(nextProps) {
    if(
      nextProps.filters._id &&
      this.props.filters._id !== nextProps.filters._id
    ) {
      const columns = Object.keys(nextProps.filters).filter(filter =>
        Boolean(
          nextProps.filters[filter].options &&
          nextProps.filters[filter].options.column
        )
      );
      this.setState({visibleColumns: columns}, () => {
        this.renderColumns(nextProps.filters, this.state.visibleColumns);
      });
    }
  }

  historyReport = id => {
    // this.clearLabelData();
    const {match} = this.props;
    this.props.history.push(`${match.url}/history-report/spare/${id}`);
  };

  handleColumnChange = (value, array) => {
    const {filters} = this.props;
    this.renderColumns(filters, value);
  };

  handleFilter = (selectedKeys, confirm, data) => {
    const query = {...this.props.query};
    query.filters[data.field] = JSON.stringify({
      value: selectedKeys,
      type: data.type,
      field: data.field
    });
    this.props.saveResourceQuery(query);
    confirm();
    this.fetchList();
  };

  handleReset = (clearFilters, data) => {
    const query = {...this.props.query};
    delete query.filters[data.field];
    this.props.saveResourceQuery(query);
    clearFilters();
    this.fetchList();
  };

  handleChange = (pagination, filters, sorter) => {
    const query = {...this.props.query};
    query.pagination = {...query.pagination, current: pagination.current};
    query.sort = sorter;

    this.props.saveResourceQuery(query);
    this.fetchList();
  };

  handleFormChange = changedFields => {
    this.setState(({fields}) => ({
      fields: {...fields, ...changedFields}
    }));
  };

  fetchSpare = value => {
    if(value && value.length >= 2)
      this.props.fetchRelationshipSearchData(value, 'SparePart', 'name');
  };

  fetchSpareType = value => {
    if(value)
      this.props.fetchSparePartType(value);
  };

  renderColumns = (filters, selectedColumns) => {
    filters = filters || this.props.filters;
    const columns = [];
    const {resourceName} = this.props;

    Object.keys(filters).forEach(item => {
      if(item === "_id") {
        return;
      }

      if(selectedColumns.indexOf(item) === -1) {
        return;
      }

      columns.push({
        title: sanitizeFieldName(item),
        dataIndex: filters[item].field,
        sorter: true,
        render: value =>
          getRenderForFieldByType(value, filters[item].type, item),
        ...getColumnSearchProps(
          filters[item],
          this.handleFilter,
          this.handleReset,
          resourceName
        )
      });
    });

    columns.push({
      title: "Action",
      key: "action",
      render: record => (
        <div>
          <AccessControl
            resource={this.props.resourceName}
            permissionNeeded={"u"}
            roles={this.props.authUser ? this.props.authUser.roles : []}
            render={props => {
              return (
                <Button
                  type="primary"
                  size="small"
                  onClick={() => this.edit(record._id)}
                >
                  Edit
                </Button>
              );
            }}
          />

          <AccessControl
            resource={this.props.resourceName}
            permissionNeeded={"u"}
            roles={this.props.authUser ? this.props.authUser.roles : []}
            render={props => {
              const isActive = !!(record && record.isActive);
              const isLoading = this.state.togglingActiveId === (record && record._id);
              return (
                <Popconfirm
                  title={
                    isActive
                      ? "Are you sure you want to deactivate this spare part?"
                      : "Are you sure you want to activate this spare part?"
                  }
                  onConfirm={() => this.toggleIsActive(record)}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button
                    style={{marginLeft: "10px"}}
                    type={isActive ? "default" : "primary"}
                    size="small"
                    loading={isLoading}
                    disabled={isLoading}
                  >
                    {isActive ? "Deactivate" : "Activate"}
                  </Button>
                </Popconfirm>
              );
            }}
          />

          <AccessControl
            resource={this.props.resourceName}
            permissionNeeded={"d"}
            roles={this.props.authUser ? this.props.authUser.roles : []}
            render={props => {
              return (
                <Popconfirm
                  title="Are you sure you want to delete this record?"
                  onConfirm={() => {
                    this.deleteResource(record._id);
                  }}
                  onCancel={this.cancelDelete}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button
                    style={{marginLeft: "10px"}}
                    type="danger"
                    size="small"
                  >
                    Delete
                  </Button>
                </Popconfirm>
              );
            }}
          />

          <AccessControl
            resource={this.props.resourceName}
            permissionNeeded={"report"}
            roles={this.props.authUser ? this.props.authUser.roles : []}
            render={props => {
              return (
                <Button
                  style={{marginLeft: "10px"}}
                  type="default"
                  size="small"
                  onClick={() => this.historyReport(record._id)}
                >
                  Purchase Report
                </Button>
              );
            }}
          />
        </div>
      )
    });

    this.setState({
      visibleColumns: selectedColumns,
      columns
    });
  };

  // clearAll = () => {
  //   this.props.saveResourceQuery(this.initialQueryState);
  //   this.fetchList();
  // };

  clearAll = () => {
    const clearQueryState = {
      sort: {
        field: '',
        order: ''
      },
      pagination: {
        pageSize: 10,
        current: 1
      },
      filters: {},
    };
    //this.props.saveResourceQuery(this.initialQueryState);
    this.props.saveResourceQuery(clearQueryState);
    this.fetchList();
  };

  fetchList = () => {
    this.props.getResource();
  };

  createResource = values => {
    this.props.createResource(values);
  };

  updateResource = (values, id) => {
    this.props.updateResource(values, id);
  };

  deleteResource = id => {
    this.props.deleteResource(id);
  };

  toggleIsActive = async record => {
    if(!record || !record._id) return;

    const nextActive = record.isActive ? 0 : 1;
    try {
      this.setState({togglingActiveId: record._id});
      await axios.put(
        `/spare-part/toggle-is-active/${record._id}?active=${nextActive}`
      );
      message.success(nextActive ? "Activated" : "Deactivated");
      this.fetchList();
    } catch(error) {
      const apiMsg =
        error &&
        error.response &&
        error.response.data &&
        error.response.data.message;
      message.error(apiMsg || "Failed to update active status");
    } finally {
      this.setState({togglingActiveId: null});
    }
  };

  cancelDelete = () => {
    message.error("Cancelled");
  };

  create = () => {
    const {match} = this.props;
    this.props.history.push(`${match.url}/add`);
  };

  edit = id => {
    const {match} = this.props;
    this.props.history.push(`${match.url}/edit/${id}`);
  };

  downloadToCSV = () => {
    const columns = [];
    this.state.columns.map(
      column =>
        column.title !== "Action" && columns.push(_.camelCase(column.title))
    );
    this.props.getResourceForDownload(
      JSON.stringify(columns),
      this.props.filters,
      "SparePart"
    );
  };

  render() {
    const {
      match,
      data,
      resource,
      edit,
      fetchResource,
      loading,
      filters,
      modules,
      authUser,
      resourceName
    } = this.props;
    const {columns, visibleColumns} = this.state;
    faviconDynamicFunction(authUser);

    return (
      <div>
        <h2>{sanitizeFieldName(resourceName)}</h2>

        <Switch>
          <Route
            path={`${match.url}`}
            exact
            render={() => (
              <List
                columns={columns}
                visibleColumn={visibleColumns}
                data={data}
                clearFilter={this.clearAll}
                filters={filters}
                handleChange={this.handleChange}
                columnChange={this.handleColumnChange}
                downloadToCSV={this.downloadToCSV}
                title={resourceName}
                size={"middle"}
                create={this.create}
                pagination={this.props.query.pagination}
                loading={loading}
                authUser={authUser}
              />
            )}
          />
          <Route
            path={`${match.url}/create`}
            render={props => (
              <Create
                data={{}}
                filters={filters}
                modules={modules}
                title={"CREATE"}
                resource={resourceName}
                onChange={this.handleFormChange}
                onSubmit={this.createResource}
                loading={loading}
                {...props}
              />
            )}
          />
          <Route
            path={`${match.url}/edit/:id`}
            render={props => (
              <StepCreate
                data={edit}
                filters={filters}
                modules={modules}
                title={"EDIT"}
                resource={resourceName}
                fetch={fetchResource}
                onChange={this.handleFormChange}
                generateSpareName={this.props.generateSparePartName}
                clearName={this.props.sparePartNameGenerationClear}
                autoSpareName={this.props.autoSpareName}
                submitPayload={this.props.submitPayload}
                onSubmit={this.props.createNewSpare}
                fetchSpare={this.fetchSpare}
                fetchSpareType={this.fetchSpareType}
                sparePartTypeData={this.props.sparePartTypeData}
                sparePartData={this.props.sparePartData}
                loading={loading}
                subDocumentFilters={this.props.subDocumentFilters}
                {...props}
              />
              // <Create
              //   data={edit}
              //   filters={filters}
              //   modules={modules}
              //   title={"EDIT"}
              //   resource={resourceName}
              //   fetch={fetchResource}
              //   onChange={this.handleFormChange}
              //   onSubmit={this.updateResource}
              //   loading={loading}
              //   {...props}
              // />
            )}
          />

          <Route
            path={`${match.url}/history-report/spare/:id`}
            render={props => <PurchaseHistory loading={loading} {...props} />}
          />
          <Route
            path={`${match.url}/add`}
            render={props => (
              <StepCreate
                data={{}}
                filters={filters}
                modules={modules}
                title={"CREATE"}
                resource={resourceName}
                onChange={this.handleFormChange}
                generateSpareName={this.props.generateSparePartName}
                clearName={this.props.sparePartNameGenerationClear}
                autoSpareName={this.props.autoSpareName}
                submitPayload={this.props.submitPayload}
                onSubmit={this.props.createNewSpare}
                fetchSpare={this.fetchSpare}
                sparePartData={this.props.sparePartData}
                subDocumentFilters={this.props.subDocumentFilters}
                loading={loading}
                {...props}
              />
            )}
          />
        </Switch>
      </div>
    );
  }
}

const mapStateToProps = ({auth, sparePart, commonData, sparePartType}) => {
  return {
    authUser: auth.authUser,
    total: sparePart.total,
    data: sparePart.resources,
    resource: sparePart.resource,
    edit: sparePart.edit,
    query: sparePart.query,
    loading: commonData.loading,
    filters: commonData.filters,
    modules: commonData.modules,
    mergeData: sparePart.mergeableSpares,
    autoSpareName: sparePart.generatedSpareName,
    submitPayload: sparePart.submitPayload,
    sparePartData: commonData.relationshipSearch,
    sparePartTypeData: sparePartType.edit,
    subDocumentFilters: commonData.subDocumentFilters,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    getResource,
    getResourceForDownload,
    createResource,
    fetchResource,
    updateResource,
    deleteResource,
    saveResourceQuery,
    fetchFilter,
    createNewSpare,
    generateSparePartName,
    sparePartNameGenerationClear,
    fetchRelationshipSearchData,
    fetchSparePartType
  };
}

export default connect(mapStateToProps, mapDispatchToProps())(SparePart);
